import { render, staticRenderFns } from "./MultiSelect.vue?vue&type=template&id=288128a7"
import script from "./MultiSelect.vue?vue&type=script&lang=ts"
export * from "./MultiSelect.vue?vue&type=script&lang=ts"
import style0 from "./MultiSelect.vue?vue&type=style&index=0&id=288128a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports